var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({position: 'sticky', bottom: 0, 'z-index': 1})},[(_vm.participants.length > 1)?_c('b-alert',{staticClass:"participants-alert mb-0",attrs:{"show":"","variant":"info"}},[_vm._v("\n    This page is in use by "),_c('b',[_vm._v(_vm._s(_vm.participantsString)+" ")]),_vm._v("at the same\n    time.\n  ")]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0146390e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Presence.vue
// module id = null
// module chunks = 